module.exports = __webpack_public_path__ + "static/media/detail_0016_t.775edf2b.jpg";